import styled from "styled-components";
import CowInCircle from "./cowInCircle2";

import handleSelectedImg from "./programmeHeader.png";

const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 40%; /* Adjust this to match your image aspect ratio */
  overflow: visible;
`;

const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const OverlayCircle = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  transform: translate(-50%, 50%) scale(1.6);
`;

export default function ImageWithCowOverlay() {
  return (
    <Container>
      <ImageWrapper>
        <BackgroundImage
          src={handleSelectedImg}
          alt="Harvest scene with machinery"
        />
        <OverlayCircle>
          <CowInCircle />
        </OverlayCircle>
      </ImageWrapper>
    </Container>
  );
}
